// src/components/pages/Pessoa/boot/getPessoaBootBase.js

export function getPessoaBootBase({ empresaId } = {}) {
    return {
        empresaId: empresaId || null,
        ativo: true,
        tipo: 'Física',
        vinculoFinanceiro: 'Ambos',

        funcionario: false,
        usuario: false,
        fabricante: false,
        simplesNacional: false,

        administrador: false,
        locador: false,
        locatario: false,
        fiador: false,

        nomePrincipal: '',
        CPForCNPJ: '',
        RGorIE: '',
        inscricaoEstadualST: '',
    };
}
